import { DatePicker, Form, Input } from "antd";
import dayjs from "dayjs";
import * as React from "react";
import { ZSysDataHistory } from "src/business/sysData/ZSysData";
import { dateTimeViewFormat } from "src/common/dateTime";

type SystemDataFormValues = {
  createdAt: dayjs.Dayjs | null;
  updatedAt: dayjs.Dayjs | null;
  createdBy: string;
  updatedBy: string;
};

const data2form = (
  data: ZSysDataHistory | undefined,
): SystemDataFormValues => ({
  createdAt: data?.createdAt ? dayjs.utc(data.createdAt) : null,
  updatedAt: data?.updatedAt ? dayjs.utc(data.updatedAt) : null,
  createdBy: data?.createdBy?.label ?? "",
  updatedBy: data?.updatedBy?.label ?? "",
});

type PropsSysDataFormItems = {
  data?: ZSysDataHistory;
};
export const SysDataFormItems: React.FC<PropsSysDataFormItems> = ({ data }) => {
  const dateTimeFormat = dateTimeViewFormat();
  const formValues = data2form(data);
  return (
    <>
      <Form.Item label="Дата создания" layout="vertical">
        <DatePicker
          value={formValues.createdAt}
          format={dateTimeFormat}
          showTime
          disabled
          style={{ width: "100%" }}
        />
      </Form.Item>
      <Form.Item label="Дата последнего изменения" layout="vertical">
        <DatePicker
          value={formValues.updatedAt}
          format={dateTimeFormat}
          showTime
          disabled
          style={{ width: "100%" }}
        />
      </Form.Item>
      <Form.Item label="Автор создания" layout="vertical">
        <Input value={formValues.createdBy} disabled />
      </Form.Item>
      <Form.Item label="Автор последнего изменения" layout="vertical">
        <Input value={formValues.updatedBy} disabled />
      </Form.Item>
    </>
  );
};
